import styled from "styled-components";

export const Container = styled.div<{ selectedArea?: boolean }>`
  min-width: ${({ selectedArea }) => (selectedArea ? "1070px" : "initial")};
`;

export const TabsNavigationWrapper = styled.div`
  position: relative;
`;

export const Content = styled.div`
  margin: 25px 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const HeaderWrapper = styled.div<{ $isVisible: boolean }>`
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transform: ${({ $isVisible }) =>
    $isVisible ? "translateY(0)" : "translateY(-20px)"};
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  pointer-events: ${({ $isVisible }) => ($isVisible ? "auto" : "none")};
`;

export const Row = styled.div`
  display: flex;
`;

export const Column = styled.div`
  margin-right: 25px;
`;

export const MassEditContainer = styled.div<{
  $isFixed?: boolean;
  $tabsHeight?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: ${({ $isFixed }) => ($isFixed ? "fixed" : "relative")};
  top: ${({ $isFixed, $tabsHeight }) =>
    $isFixed ? `${$tabsHeight || 0}px` : "auto"};
  left: ${({ $isFixed }) => ($isFixed ? "0" : "auto")};
  right: ${({ $isFixed }) => ($isFixed ? "0" : "auto")};
  z-index: ${({ $isFixed }) => ($isFixed ? 1000 : "auto")};
  background-color: ${({ $isFixed, theme }) =>
    $isFixed ? theme.palette.background.default : "transparent"};
  padding: ${({ $isFixed }) => ($isFixed ? "16px 15px 16px 0" : "0")};
  margin: ${({ $isFixed }) => ($isFixed ? "0" : "0")};
  box-shadow: ${({ $isFixed }) =>
    $isFixed ? "0 2px 4px rgba(0, 0, 0, 0.1)" : "none"};
  width: ${({ $isFixed }) => ($isFixed ? "100%" : "auto")};
`;

export const MassEditButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-left: auto;
`;

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CancelEditModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 20px;
  padding: 20px;

  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.background.default};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  width: 525px;
  height: 220px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const CancelEditModalButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
